import { useState } from 'react';
import { ReplyTypeClient, ReplyTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useReplyTypeApi = () => {
    const apiClient = new ReplyTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ReplyTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createReplyType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ReplyType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ReplyTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateReplyType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ReplyType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getReplyTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ReplyType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchReplyTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ReplyTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteReplyType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ReplyType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};